import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import UM from 'UM';
import storage from '@/utils/cookie';
import { Layout, Row, Col, Button, Select, Input, Rate, message, Radio, Checkbox } from 'antd';
// import { PropTypes } from 'prop-types';
// personal component
import * as questionManageType from '@/utils/questionManageType';
import { action as userInfoAction } from './';
import { SUBJECT_TYPE, CONFIGURATION_ITEM, RELATE_MAP, contentInputType, DISPLAT_QUESTION_TYPE, OPTION_INPUT_TYPE, LETTER_MAP, TYPE_SHOW, TYPE_SHOW_REVERSE } from './constData';
import StemEditor from './components/stem_editor/view';
import OptionEditor from './components/option_editor/view';
import { SUBJECT_STEM_STYLE } from '@/utils/questionManageType';
import Editor from '@/entry_question_editor/question/common/editor';
import { getToolbars } from '@/utils/questionManageType';
import KnowledgeBox from '@/entry_app/question_manage/set_tag/question_tag_detail/knowledge_box/view';
import { replaceCommonTags } from '@/utils/getEditorContent.js';
import { setAddEditTemplateAPI, getTemplateDetailAPI } from '@/API';
import { reverseParseText as reverseParseTextSelect } from '@/entry_question_editor/question/select/createRender';
import { reverseParseText as reverseParseTextJudge } from '@/entry_question_editor/question/judge/createRender';
import '@/css/question_manage.less';

// 参数
const ButtonGroup = Button.Group;
const Option = Select.Option;
const RadioGroup = Radio.Group;
const { Header, Footer, Content } = Layout;
let temp_id = ''; // 模版id

class QuestionTML extends Component {
    // static contextTypes = {
	// 	router: PropTypes.object.isRequired
    // };
    
    state = {
        name: '', // 模版名
        questionStyle: "select", // select-选择，judge-判断
        answer: '1', // 1-对，0-错
        well_chosen: '', // 11-基础， 12-进阶
        questionColorGray: false, // 题干文字颜色
        difficuty: 1, // 难度
        questionType: '', // 展示题型
        optionNum: 1, // 段落个数
        selectStemStyle: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0], // 选择段落样式
        contentInputStype: ["rich_text","rich_text","rich_text","rich_text","rich_text","rich_text","rich_text","rich_text","rich_text","rich_text","rich_text","rich_text","rich_text","rich_text","rich_text"], // 内容录入方式
        stemList: [ // 题干内容列表
            {textArea: '', audio: '', img: ''},
            {textArea: '', audio: '', img: ''},
            {textArea: '', audio: '', img: ''},
            {textArea: '', audio: '', img: ''},
            {textArea: '', audio: '', img: ''},
            {textArea: '', audio: '', img: ''},
            {textArea: '', audio: '', img: ''},
            {textArea: '', audio: '', img: ''},
            {textArea: '', audio: '', img: ''},
            {textArea: '', audio: '', img: ''},
            {textArea: '', audio: '', img: ''},
            {textArea: '', audio: '', img: ''},
            {textArea: '', audio: '', img: ''},
            {textArea: '', audio: '', img: ''},
            {textArea: '', audio: '', img: ''},
        ], 
        isSetDefaultGuide: false, // 是否设置默认引导语
        isShowGetGuide: false, // 是否引用默认引导语
        guideCurrentStem: '', // 引导语当前要插入哪个段落
        guideList: [ // 引导语列表
            {
                "key_words": "",
                "content": "",
                "list": [
                    {
                        key_words: '', // 听音，判断单词与所听内容是否一致
                        content: ''
                    },
                ]
            },
        ],
        know_list: [
            {
                "type": 21,
                "title": "知识点",
                "pre_type": 0,
                "selected": []
            }, 
            {
                "type": 122,
                "title": "考点",
                "pre_type": 21,
                "selected": []
            },
            {
                "type": 24,
                "title": "能力标签",
                "pre_type": 0,
                "selected": []
            }
        ],
        conf_show_list: [],
        // 选项
        currentOptionNum: 4, // 默认当前选项的个数
        optionInputWay: 'rich_text', // 选项默认录入方式
        rightAnswer: '', // 选项正确的答案
        optionList: [ // 选项内容列表
            {textArea: '', audio: '', img: ''},
            {textArea: '', audio: '', img: ''},
            {textArea: '', audio: '', img: ''},
            {textArea: '', audio: '', img: ''},
            {textArea: '', audio: '', img: ''},
            {textArea: '', audio: '', img: ''},
            {textArea: '', audio: '', img: ''},
            {textArea: '', audio: '', img: ''},
            {textArea: '', audio: '', img: ''},
            {textArea: '', audio: '', img: ''},
            {textArea: '', audio: '', img: ''},
            {textArea: '', audio: '', img: ''},
            {textArea: '', audio: '', img: ''},
            {textArea: '', audio: '', img: ''},
            {textArea: '', audio: '', img: ''},
        ]
    }

    componentWillMount() {
        const token = storage.getData('UCENTER_IUCTOKEN');
        temp_id = this.props.match.params[0]; // temp_id

        !token && this.props.history.push('/login');
        this.props.setCateitemList({}, () => { // cateitem_list
            const { cateitem_list } = this.props;
            let new_cateitem_list = [...cateitem_list];

            new_cateitem_list.forEach(item => {
                if (!item.list) {
                    item.list = [];
                }
            });
            this.props.editParam({cateitem_list: new_cateitem_list});
        }); 
	}

    componentDidMount() {
        if(storage.getData('UCENTER_IUCTOKEN')) {
            this.props.getUserInfo({}, () => {
                const { subject } = this.props;
                let stem_style = SUBJECT_STEM_STYLE[subject];
                this.props.editParam({stem_style});
            });
            this.props.changePath('questionbox');
        }
        if (temp_id) {
            getTemplateDetailAPI({temp_id}).then(res => {
                const { info, list } = res.data;
                this.initData(info, list)
            }).catch(err => {
                console.log(err)
            })
        }
        let questionColorGray = localStorage.getItem('questionColorGray');
        questionColorGray = questionColorGray === 'true' ? true : false;
        this.setState({questionColorGray});
    }

    // 初始化数据
    initData = (info, list) => {
        const { optionList, stemList, selectStemStyle, contentInputStype } = this.state;
        let { answer, know_list, cateitem_list, item_list, conf_show_list, difficulty, display_type, item_type, name, stem_type_list, type_show, well_chosen } = info;
        let newContentInputStype = [...contentInputStype];
        for (let i = 0; i < stem_type_list.length; i++) {
            newContentInputStype[i] = stem_type_list[i];
        }
        let data = {
            name,
            answer,
            difficuty: difficulty,
            questionType: display_type,
            conf_show_list,
            optionInputWay: item_type,
            contentInputStype: newContentInputStype,
            questionStyle: TYPE_SHOW_REVERSE[type_show],
            well_chosen,
            guideList: list.length > 0 ? list : this.state.guideList,
            know_list,
            optionNum: stem_type_list.length,
            currentOptionNum: item_list ? item_list.length : 4,
        }, reverseData = {};

        switch(+type_show) {
            case 21: // 选择题
                reverseData = reverseParseTextSelect(info);
                data.rightAnswer = reverseData.answer[0]; // 答案
                // 选项
                let option = reverseData.options;
                switch (item_type) {
                    case 'text': 
                        let newOptionList = [...optionList];
                        for (let i = 0; i < option.length; i++) {
                            let newStr = option[i].item.replace(/<\/p><p>/g, '\r')
                            newStr = newStr.replace(/<p>|<\/p>/g, '');
                            newOptionList[i].textArea = newStr;
                        }
                        data.optionList = newOptionList;
                        break;
                    case 'rich_text': 
                        for (let i = 0; i < option.length; i++) {
                            let content = option[i].item;
                            setTimeout(() => {
                                UM.getEditor(`option_template_${i+1}`).setContent(content);
                            }, 0)    
                        }
                        break;
                    case 'audio': 
                        let newOptionList1 = [...optionList];
                        for (let i = 0; i < option.length; i++) {
                            let reg = /src="(.*)" controls/g;
                            let regS = reg.exec(option[i].item);
                            newOptionList1[i].audio = regS ? regS[1] : '';
                        }
                        data.optionList = newOptionList1;
                        break;
                    case 'image': 
                        let newOptionList2 = [...optionList];
                        for (let i = 0; i < option.length; i++) {
                            let reg = /src="(.*)" class/g;
                            let regS = reg.exec(option[i].item);
                            newOptionList2[i].img = regS ? regS[1]: '';
                        }
                        data.optionList = newOptionList2;
                        break;
                }
                break;
            case 25: // 判断题
                reverseData = reverseParseTextJudge(info);
                // 答案
                data.answer = reverseData.answer;
                break;
        }

        let stemObj= reverseData.stem;
        let styleObj = reverseData.style;
        let stemListText = [...stemList];
        let selectStemStyleText = [...selectStemStyle];
        stem_type_list.forEach((value, index) => {
            let styleCnt = styleObj[`paragraph${index}`];
            let textContent = stemObj[`paragraph${index}`];
            selectStemStyleText[index] = styleCnt;
            
            switch(value) {
                case 'text': 
                    let textCnt = textContent.replace(/<\/p><p>/g, '\r').replace(/<p>|<\/p>|<br\/>/g, '');
                    stemListText[index].textArea = textCnt;
                    break;
                case 'rich_text': 
                    setTimeout(() => {
                        UM.getEditor(`stem_template_${index+1}`).setContent(textContent);
                    }, 0)
                    break;
                case 'audio': 
                    let regAudio = /src="(.*)" controls/g;
                    let regAudioExec = regAudio.exec(textContent);
                    stemListText[index].audio = regAudioExec ? regAudioExec[1] : '';
                    break;
                case 'image': 
                    let regImage = /src="(.*)" class/g;
                    let regImageExec = regImage.exec(textContent);
                    stemListText[index].img = regImageExec ? regImageExec[1] : '';
                    break;     
            }
        })
        
        data.stemList = stemListText;
        data.selectStemStyle = selectStemStyleText;
        let explain = reverseData.explain;
        UM.getEditor('explain').setContent(explain);
        this.props.editParam({cateitem_list});
        this.setState(data);
    }
    
    // 退出登陆
    loginOut = (e) => {
        storage.delData('UCENTER_IUCTOKEN');
        this.props.exitLogin({}, () => {
            window.token = '';
			this.context.router.history.push('/login');
			this.props.changePath('login');
        });
    };

    // 设置成初始化数据
    setDefaultDate = () => {
        this.setState({
            name: '',
            questionType: '',
            difficuty: 1,
            optionNum: 1,
            selectStemStyle: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
            contentInputStype: ["rich_text","rich_text","rich_text","rich_text","rich_text","rich_text","rich_text","rich_text","rich_text","rich_text","rich_text","rich_text","rich_text","rich_text","rich_text"],
            stemList: [
                {textArea: '', audio: '', img: ''},
                {textArea: '', audio: '', img: ''},
                {textArea: '', audio: '', img: ''},
                {textArea: '', audio: '', img: ''},
                {textArea: '', audio: '', img: ''},
                {textArea: '', audio: '', img: ''},
                {textArea: '', audio: '', img: ''},
                {textArea: '', audio: '', img: ''},
                {textArea: '', audio: '', img: ''},
                {textArea: '', audio: '', img: ''},
                {textArea: '', audio: '', img: ''},
                {textArea: '', audio: '', img: ''},
                {textArea: '', audio: '', img: ''},
                {textArea: '', audio: '', img: ''},
                {textArea: '', audio: '', img: ''},
            ], 
            isSetDefaultGuide: false,
            isShowGetGuide: false,
            guideList: [ // 引导语列表
                {
                    "key_words": "",
                    "content": "",
                    "list": [
                        {
                            key_words: "",
                            content: ""
                        },
                    ]
                },
            ],
            know_list: [
                {
                    "type": 21,
                    "title": "知识点",
                    "pre_type": 0,
                    "selected": []
                }, 
                {
                    "type": 122,
                    "title": "考点",
                    "pre_type": 21,
                    "selected": []
                },
                {
                    "type": 24,
                    "title": "能力标签",
                    "pre_type": 0,
                    "selected": []
                }
            ],
            conf_show_list: [],
            currentOptionNum: 4, // 默认当前选项的个数
            optionInputWay: 'rich_text', // 选项默认录入方式
            rightAnswer: '', // 选项正确的答案
            optionList: [ // 选项内容列表
                {textArea: '', audio: '', img: ''},
                {textArea: '', audio: '', img: ''},
                {textArea: '', audio: '', img: ''},
                {textArea: '', audio: '', img: ''},
                {textArea: '', audio: '', img: ''},
                {textArea: '', audio: '', img: ''},
                {textArea: '', audio: '', img: ''},
                {textArea: '', audio: '', img: ''},
                {textArea: '', audio: '', img: ''},
                {textArea: '', audio: '', img: ''},
                {textArea: '', audio: '', img: ''},
                {textArea: '', audio: '', img: ''},
                {textArea: '', audio: '', img: ''},
                {textArea: '', audio: '', img: ''},
                {textArea: '', audio: '', img: ''},
            ]
        });
    }

    // 切换题型
    handleToggleType = val => {
        // 数据清空
        this.setState({
            questionStyle: val,
        });
        this.setDefaultDate();
    }

    // 修改学科学段
	handleClick = (grade_part, subject, str) => {
        this.props.modifySubjectInfo({grade_part, subject}, () => {
            message.success(`修改${str}成功`);
            window.location.reload();
        }, (res) => {
            message.error(res.message);
        });
    }
    
    // 提干置灰
    handleToggleColor = () => {
        const { questionColorGray } = this.state;
        localStorage.setItem('questionColorGray', !questionColorGray);
        this.setState({questionColorGray: !questionColorGray})
    }

    // 改变段落个数
    handleOptionChange = num => {
        if (num > 15) {
            message.error('题干不能超过15个！')
        }
        const { selectStemStyle, contentInputStype, stemList} = this.state;
        let newSelectStemStyle = [...selectStemStyle];
        let newContentInputStype = [...contentInputStype];
        let newStemList = [...stemList];

        for (let i = num; i < 15; i++) {
            newSelectStemStyle[i] = 0;
            newContentInputStype[i] = 'rich_text';
            newStemList[i] = {
                textArea: '', audio: '', img: ''
            }
        }
        this.setState({
            optionNum: num, 
            selectStemStyle: newSelectStemStyle,
            contentInputStype: newContentInputStype,
            stemList: newStemList
        });
    }

    // 段落样式发生变化
    handleStemStyleChange = (value, index) => {
        const { selectStemStyle, contentInputStype } = this.state;
        const newStemStyle = [...selectStemStyle];
        const newContentInputStype = [...contentInputStype];
        newStemStyle[index] = value;

        // 如果段落样式为引导语，内容输入方式为文本框
        newContentInputStype[index] = contentInputType(value)[0].text;
        
        this.setState({
            selectStemStyle: newStemStyle,
            contentInputStype: newContentInputStype
        });
    }

    // 内容输入方式变化
    handleContentInputChange = (value, index) => {
        const { contentInputStype } = this.state;
        const newInputStyle = [...contentInputStype];
        newInputStyle[index] = value;
        this.setState({contentInputStype: newInputStyle});
    }

    // 题干列表
    handleEdittStemList = obj => {
        this.setState(obj);
    }

    // 切换答案
    handleToggleAnswer = num => {
        this.setState({answer: num});
    }

    // 更改题目难度
    onChangeDifficuty = value => {
       this.setState({difficuty: value});
    }

    // 展示题型发生变化
    onChangeQuestionType = value => {
        this.setState({questionType: value})
    }

    // 切换题包
    onWellChoseChange = e => {
        this.setState({well_chosen: e.target.value})
    }

    // 选中的配置项
    onCheckoutChange = e => {
        const { conf_show_list } = this.state;
        let confShowList = [...conf_show_list];
        if (e.target.checked) { //true
            confShowList.push(e.target.value);
        }
        else {
            let index = confShowList.indexOf(e.target.value);
            confShowList.splice(index, 1);
        }
        this.setState({conf_show_list: confShowList});
    }

    // 会写生字/生词内容改变
    onInputWordChange = (e, diff) => {
        const { cateitem_list } = this.props;
        const new_cateitem_list = [...cateitem_list];
        let newList = e.target.value.split('|');

        new_cateitem_list.forEach(item => {
            if (item.group === RELATE_MAP[diff]) {
                item = Object.assign(item, {
                    list: newList
                });
            }
        });

        this.props.editParam({cateitem_list: new_cateitem_list});
    }

    // 更新模版名
    onUpdataName = e => {
        this.setState({name: e.target.value});
    }

    // 选项个数发生变化
    onOptionChange = num => {
        if (num > 15) {
            message.error('选项不能超过15个！')
        }

        this.setState({
            currentOptionNum: num
        })
    }

    // 选项-内容输入方式发生变化
    onContentInputStyleChange = num => {
        this.setState({
            optionInputWay: num
        })
    }

    // 选项答案发生变化
    onRadioChange = e => {
        this.setState({
            rightAnswer: e.target.value
        })
    }

    // 转义
    onTransferred = () => {} 

    onSaveTemplate = () => {
        let { questionStyle, currentOptionNum, answer, stemList, optionNum, name, difficuty, questionType, well_chosen, know_list, conf_show_list, optionInputWay, contentInputStype, selectStemStyle, rightAnswer, optionList, guideList } = this.state;
        const { cateitem_list } = this.props;
        const content = [];
        let stem_type_list = [...contentInputStype];
        let currentStemStyle = [...selectStemStyle];

        // 判断段落样式是否为空
        stem_type_list = stem_type_list.splice(0, optionNum);
        currentStemStyle = currentStemStyle.splice(0, optionNum);
        for (let i = 0; i < currentStemStyle.length; i++) {
            let type = currentStemStyle[i];
            let textContent = '', innerStr = '';
            if (type == 0) {
                message.error(`段落${i+1}样式不能为空`);
                return;
            }
            let inputType = stem_type_list[i];
            // 获取题干内容
            switch (inputType) {
                case 'text': 
                    let textAreaContent = stemList[i].textArea;
                    textAreaContent = textAreaContent.replace(/[\n\r]/ig, '<br>');
                    let textArr = textAreaContent.split('<br>');
                    textArr = textArr.map(item => {
                        return `<p>${item}</p>`
                    });
                    textContent = textArr.join('');
                    break;
                case 'rich_text': 
                    textContent = UM.getEditor(`stem_template_${i+1}`).getContent();
                    break;
                case 'audio':
                    let audioValue =  stemList[i].audio;
                    textContent = `<p><audio  src="${audioValue}" controls="controls">您的浏览器不支持</audio></p>`
                    break;
                case 'image': 
                    let imgSrc = stemList[i].img;
                    textContent = `<p><img src="${imgSrc}" _src="${imgSrc}" width="px1336" height="px1292" class="mis_bigger_image" /></p>`;
                    break;
            }
            
            innerStr = replaceCommonTags(textContent);
            content.push(`#{"type":"para_begin","style":"${currentStemStyle[i]}"}#${innerStr}#{"type":"para_end"}#`)
        }

        // 答案
        let answerArr = [], item_list = [], itemContent = '', itemStr = '';
        if ( questionStyle === 'select') {
            // 答案
            answerArr = [{blank_id:1, choice: rightAnswer}];
            answer = JSON.stringify(answerArr);
            for (let j = 0; j < currentOptionNum; j++) {
                switch (optionInputWay) {
                    case 'text': 
                        let textAreaContent = optionList[j].textArea;
                        textAreaContent = textAreaContent.replace(/[\n\r]/ig, '<br>');
                        let textArr = textAreaContent.split('<br>');
                        textArr = textArr.map(item => {
                            return `<p>${item}</p>`
                        });
                        itemContent = textArr.join('');
                        break;
                    case 'rich_text': 
                        itemContent = UM.getEditor(`option_template_${j+1}`).getContent();
                        break;
                    case 'audio':
                        let audioValue =  optionList[j].audio;
                        itemContent = `<p><audio  src="${audioValue}" controls="controls">您的浏览器不支持</audio></p>`
                        break;
                    case 'image': 
                        let imgSrc = optionList[j].img;
                        itemContent = `<p><img src="${imgSrc}" _src="${imgSrc}" width="px1336" height="px1292" class="mis_bigger_image" /></p>`;
                        break;
                }
                itemStr = replaceCommonTags(itemContent);
                item_list.push({code: LETTER_MAP[j], item: itemStr, question_item_id: 0, item_origin: '', is_right: 0});
            }
        }
        
        // 解析
        let explain = '', explainStr = '';
        explainStr = UM.getEditor('explain').getContent();
        explain = replaceCommonTags(explainStr);

        // 题目类型
        let type_show = TYPE_SHOW[questionStyle];

        let stem = content.join('');
        // let temp_id= '';
        let data = {
            type_show,
            name,
            difficulty: difficuty,
            display_type: questionType,
            well_chosen,
            stem,
            cateitem_list,
            know_list,
            explain,
            stem_type_list, // 待确认
            answer,
            conf_show_list,
            item_list,
            item_type: optionInputWay,
            list: guideList
        }
        if (!!temp_id) {
            data.temp_id = temp_id;
        }
        setAddEditTemplateAPI(data).then((res) => {
            if (res.code == 0) {
                message.success('保存模版成功');
                setTimeout(() => {
                    window.location.reload();
                }, 500);   
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    
    render() {
        const { user, userName, subject, grade_part, stem_style, cateitem_list } = this.props;
        const { name, questionStyle, questionColorGray, difficuty, questionType, optionNum, selectStemStyle, contentInputStype, stemList, guideList, isSetDefaultGuide, answer, well_chosen, know_list, isShowGetGuide, guideCurrentStem, currentOptionNum, optionInputWay, rightAnswer, optionList, conf_show_list } = this.state;
        
        let SUBJECT_PART = user.product ? SUBJECT_TYPE[user.product] : {};
        return (
            <div className="question-template">
                <Layout>
                    <Header className="header-top">
                        <div className="head-container">
                            <div className="logo">
                                <img alt={`MIS题库平台`} src={require('@/static/img/pc-logo.jpeg')}/>
                            </div>
                            {
                                user.product &&
                                <div className="title">
                                    <span className="title-name">作业盒子-MIS</span>
                                    <Select value={grade_part} style={{width: 80, marginLeft: 15}} onSelect={val => this.handleClick(val, subject, '学段')}>
                                        {
                                            Object.keys(questionManageType.GRADE_PART).map(k=>
                                                <Option key={k} value={k}>{questionManageType.GRADE_PART[k]}</Option>
                                            )
                                        }
                                    </Select>
                                    <Select  value={subject} style={{width: 80, marginLeft: 5}} onSelect={val => this.handleClick(grade_part, val, '学科')}>
                                        {
                                            Object.keys(SUBJECT_PART).map((k)=>
                                                <Option key={k} value={k}>{SUBJECT_PART[k]}</Option>
                                            )
                                        }
                                    </Select>
                                </div>
                            }
                            <div className="user-info">
                                <div className="user-name">
                                    <div className="user-name-show">{userName}</div>
                                    <Button className="user-name-btn" type="primary" onClick={this.loginOut}>退&nbsp;&nbsp;&nbsp;&nbsp;出</Button>
                                </div>
                            </div>
                            {/*题干换颜色的部分*/}
                            <div className="user-info" style={{height: 56}}>
                                <div className="user-name">
                                    <Button type={questionColorGray ? 'primary' : ''} onClick={this.handleToggleColor}>题干灰色</Button>
                                </div>
                            </div>
                        </div>
                    </Header>
                    <Content className="content-center">
                        <p className="content-tml-name">{name}</p>
                        <Row className="content-tml-row-public" type="flex" align="middle">
                            <Col span={2} className="content-tml-public-name">题型：</Col>
                            <Col span={22}>
                                <ButtonGroup>
                                    <Button
                                        disabled={!!temp_id && questionStyle !== 'select' ? true : false}
                                        type={questionStyle === 'select' ? 'primary' : 'default'}
                                        onClick={() => this.handleToggleType('select')}
                                    >选择题</Button>
                                    <Button
                                        disabled={!!temp_id && questionStyle !== 'judge' ? true : false}
                                        type={questionStyle === 'judge' ? 'primary' : 'default'}
                                        onClick={() => this.handleToggleType('judge')}
                                    >判断题</Button>
                                </ButtonGroup>
                            </Col>
                        </Row>
                        <Row className="content-tml-row-public" type="flex" align="middle">
                            <Col span={2} className="content-tml-public-name">模版名：</Col>
                            <Col span={22}>
                                <Input value={name} style={{width: 230}} onChange={this.onUpdataName} />
                            </Col>
                        </Row>
                        <Row className="content-tml-row-public" type="flex" align="middle">
                            <Col span={2} className="content-tml-public-name">难度：</Col>
                            <Col span={22}>
                                <Rate count={4} value={+difficuty} onChange={this.onChangeDifficuty} />
                            </Col>
                        </Row>
                        <Row className="content-tml-row-public" type="flex" align="middle">
                            <Col span={2} className="content-tml-public-name">展示题型：</Col>
                            <Col span={22}>
                                <Select value={questionType} onChange={this.onChangeQuestionType} style={{width: 160}}>
                                    {
                                        DISPLAT_QUESTION_TYPE[questionStyle].map((item, index) => 
                                            <Option key={index} value={item.id}>{item.name}</Option>
                                        )
                                    }
                                </Select>
                            </Col>
                        </Row>
                        <StemEditor 
                            optionNum={optionNum}
                            subject={subject}
                            maxOptionNum={15} // 总的可选段落
                            stemStyle={stem_style} // 可选段落样式
                            selectStemStyle={selectStemStyle} // 当前段落样式列表
                            contentInputType={contentInputType} // 可选内容方式
                            contentInputStype={contentInputStype} // 当前内容方式列表
                            stemList={stemList} // 题干列表
                            guideList={guideList} // 引导语列表
                            isSetDefaultGuide={isSetDefaultGuide} // 是否设置默认引导语
                            isShowGetGuide={isShowGetGuide} // 是否引用默认引导语
                            guideCurrentStem={guideCurrentStem} // 引导语当前要插入哪个段落
                            onOptionChange={this.handleOptionChange}
                            onStemStyleChange={this.handleStemStyleChange}
                            onContentInputStyleChange={this.handleContentInputChange}
                            onEdittStemList={this.handleEdittStemList}
                        />
                        {
                            questionStyle === 'select' && 
                            <OptionEditor
                                maxOptionNum={15} // 总的可选选项个数
                                subject={subject}
                                currentOptionNum={currentOptionNum} // 当前的选项个数
                                contentInputType={OPTION_INPUT_TYPE} // 内容录入方式
                                optionInputWay={optionInputWay} // 选项默认录入方式
                                rightAnswer={rightAnswer} // 选项正确答案
                                optionList={optionList} // 选项内容列表
                                onEdittStemList={this.handleEdittStemList}
                                onOptionChange={this.onOptionChange} // 选项个数发生变化
                                onContentInputStyleChange={this.onContentInputStyleChange}
                                onRadioChange={this.onRadioChange} // 选项答案发生变化
                            />
                        }
                        {
                            questionStyle === 'judge' && 
                                <Row className="content-tml-row-public" type="flex" align="middle">
                                    <Col span={2} className="content-tml-public-name">答案：</Col>
                                    <Col span={22}>
                                        <ButtonGroup>
                                            <Button
                                                type={answer === '1' ? 'primary' : 'default'}
                                                onClick={() => this.handleToggleAnswer(1)}
                                            >对</Button>
                                            <Button
                                                type={answer === '0' ? 'primary' : 'default'}
                                                onClick={() => this.handleToggleAnswer(0)}
                                            >错</Button>
                                        </ButtonGroup>
                                    </Col>
                                </Row>
                        }
                        <Row className="content-tml-row-public" type="flex" align="middle">
                            <Col span={2} className="content-tml-public-name">所属题包：</Col>
                            <Col span={22}>
                                <RadioGroup  value={well_chosen} onChange={this.onWellChoseChange} >
                                    <Radio value="11">基础</Radio>
                                    <Radio value="12">进阶</Radio>
                                </RadioGroup>
                            </Col>
                        </Row>

                        <div className="configure-item">
                            <p className="configure-item-title">配置项：</p>
                            <div className="knowlist-group">
                                {
                                    cateitem_list.length > 0 && cateitem_list.map((item, key) => 
                                        <Checkbox key={key} checked={conf_show_list.includes(CONFIGURATION_ITEM[item.group])} value={CONFIGURATION_ITEM[item.group]} className="checkout-explain-container" style={{padding: key === cateitem_list.length-1 ? "20px 0" : 0}} onChange={this.onCheckoutChange}>
                                            <div className="checkout-explain">
                                                <p className="checkout-name">{item.name}</p>
                                                <div className="checkout-ueditor">
                                                    <Input style={{width: '680px', marginRight: '10px'}} value={item.list && item.list.length > 0 ? item.list.join('|') : ''} onChange={(e) => this.onInputWordChange(e, CONFIGURATION_ITEM[item.group])} />
                                                    <span>多个{item.name.slice(2)}之间用'|'隔开</span>
                                                </div>
                                            </div>
                                        </Checkbox>
                                    )
                                }
                                {
                                    know_list.map((val,k) =>
                                        <Checkbox key={`know${k}`} checked={conf_show_list.includes(CONFIGURATION_ITEM[val.type])} className="checkout-knowledge" value={CONFIGURATION_ITEM[val.type]} onChange={this.onCheckoutChange}>
                                            <KnowledgeBox className="knowlist-parent" data={val} select={know_list} historyData={[]} isTask={'noTask'}></KnowledgeBox>
                                        </Checkbox> 
                                    )
                                }
                                <div className="explain-checkout">
                                    <Checkbox className="checkout-explain-container" checked={conf_show_list.includes('explain')} value="explain" onChange={this.onCheckoutChange}></Checkbox>
                                    <div className="checkout-explain">
                                        <p className="checkout-name">解析</p>
                                        <div className="checkout-ueditor">
                                            <Editor id="explain" toolbar={getToolbars(subject,'stem')}/>
                                        </div>  
                                    </div>
                                </div>
                                
                            </div>  
                        </div>
                        <div className="footer-tml">
                            <Button type="primary" onClick={this.onSaveTemplate}>保存模版</Button>
                        </div>
                    </Content>
                </Layout>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    let questionTML = state.questionManage.questionTML;
	return {
        user: questionTML,
        userName: questionTML.username,
        subject: questionTML.subject,
        grade_part: questionTML.grade_part,
        stem_style: questionTML.stem_style,
        cateitem_list: questionTML.cateitem_list,
	};
}
const mapDispatchToProps = dispatch => {
	return {
        editParam: (param) => {
			dispatch(userInfoAction.editParam(param));
        },
        changePath: (path) => { // 改变path
			dispatch(userInfoAction.changePath(path));
        },
        getUserInfo: (param, sucCallback, errCallback) => { // 获取用户信息
			dispatch(userInfoAction.getUserInfo(param, sucCallback, errCallback))
        },
        modifySubjectInfo: (param, sucCallback, errCallback) => { // 修改科目信息
			dispatch(userInfoAction.modifySubjectInfo(param, sucCallback, errCallback))
        },
        exitLogin: (param, sucCallback, errCallback) => { // 推出登陆
			dispatch(userInfoAction.exitLogin(param, sucCallback, errCallback))
        },
        setCateitemList: (param, sucCallback, errCallback) => { // 会认生字，会写生字
			dispatch(userInfoAction.setCateitemList(param, sucCallback, errCallback))
        },
    }
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(QuestionTML));




// WEBPACK FOOTER //
// ./src/entry_app/question_manage/question_tml/questionTML.js